import { NgModule } from "@angular/core";
import { ControlMessagesComponent } from "./control-messages";
import { IonicModule } from "ionic-angular";

@NgModule({
  declarations: [
    ControlMessagesComponent
  ],
  imports: [
      IonicModule
  ],
  exports: [
    ControlMessagesComponent
  ]
})

export class ControlMessageModule {}



// WEBPACK FOOTER //
// ./src/vas/modules-other/control-message/control-messages.module.ts